import { http } from '@/core/api/';

export default {
  // Returns the resources according to the codes passed by parameters.
  // Usage example:
  // let resourceCodes = [
  //   "R03200109",
  //   "R03200150"
  // ];
  // this.resources = await resourcesService.LoadResources(resourceCodes);

  //DO NOT USE THIS TO GET THE VALIDATION MESSAGES DIRECTLY
  async LoadResources(resourceCodes) {
    let resources = [];

    let res = await this.GetResources(resourceCodes);
    resourceCodes.forEach(function(code) {
      resources[code] = res.find((x) => x.id === code)
        ? res.find((x) => x.id === code).name
        : '';
    });
    return resources;
  },
  //DO NOT USE THIS TO GET THE VALIDATION MESSAGES DIRECTLY
  GetResources(keys) {
    const qs = keys.join('&messageCodes=');
    const receivedKeys = keys;
    const promise = new Promise((resolve) => {
      http
        .get(`/api/validationsmessages?messageCodes=${qs}`, {
          headers: {
            loading: false,
          },
        })
        .then((res) => {
          let resources = Array.from(res.data);
          const foundIds = res.data.map((x) => x.id);
          const notFoundIds = receivedKeys.filter(
            (x) => !foundIds.some((y) => y === x)
          );
          resources = resources.concat(
            notFoundIds.map((x) => {
              //this ensures that the resource object is created anyways if is not found on the server side
              return { id: x, name: '', sortOrder: 0 };
            })
          );
          resolve(resources);
        })
        .catch((err) => {
          this.response = err;
        });
    });
    return promise;
  },
  //USE THIS METHOD TO GET THE VALIDATION MESSAGES
  async LoadValidationMessages(keys) {
    let messages = await this.GetResources(keys);

    let result = {};

    for (let i = 0; i < messages.length; i++) {
      result[messages[i].id] = messages[i].name;
    }

    return result;
  },
};
